import {Pipe, PipeTransform} from "@angular/core";
import * as $ from 'jquery';
/*
 * Description:
 *
 * Usage:
 *
 * Example:
 *
 */
@Pipe({name: "extractSource"})
export class ExtractSourcePipe implements PipeTransform {
    transform(value: any, args: string[]): any {
        return $(value).attr('src');
    }
}